module.exports = __webpack_public_path__ + "static/media/Remove.8f96378d.svg";